// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/companies/{OrgId}/contract-types",
  Detail: "/pyr/companies/{OrgId}/contract-types",
  ListShort: "/pyr/companies/{OrgId}/contract-types/short",
  Create: "/pyr/companies/{OrgId}/contract-types",
  Update: "/pyr/companies/{OrgId}/contract-types",
};
